import LinkOutlined from "@ant-design/icons/LinkOutlined";
import Title from "common/Typography/Title";
import styled from "styled-components";
import Text from "common/Typography/Text";

interface WhitelistIPsMessageProps {
  primaryExchange?: string;
}

const WhitelistIPsMessage = ({ primaryExchange }: WhitelistIPsMessageProps) => {
  return (
    <SecurityMessageWrapper $size={"S"} type="secondary" as="div">
      <LinkOutlined />
      <Title
        level={5}
        type="secondary"
        style={{ marginLeft: 4, display: "inline" }}
      >
        Quick Connect -
      </Title>{" "}
      Automatically create encrypted and IP-restricted API keys when connecting
      to {primaryExchange}
    </SecurityMessageWrapper>
  );
};
export default WhitelistIPsMessage;

const SecurityMessageWrapper = styled(Text)`
  text-align: left;
  margin-top: 16px;
  margin-bottom: 0;
  padding-top: 12px;
  border-top: ${(p) => p.theme.borders.light};
`;
